import { apiRequest } from 'api-client';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  data: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    refreshExpiresIn: number;
    user: {
      id: number;
      email: string;
      isBanned: boolean;
      isAdmin: boolean;
      firstName: string;
      lastName: string;
      avatar: string;
    };
  },
  success: boolean;
  message: string;
}

export interface CodeRequestPayload {
  email: string;
}

export interface CodeVerificationPayload {
  email: string;
  loginCode: string;
}

export interface ForgotPasswordPayload {
  email: string;
}

export interface ResetPasswordPayload {
  email: string;
  verificationCode: string;
  newPassword: string;
}

export interface RegisterPayload {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

// Example API functions using the configured axios instance
export const authAPI = {
  // Login with email and password
  login: (credentials: LoginCredentials): Promise<LoginResponse> => {
    return apiRequest.post('/auth/login', credentials);
  },

  // Request verification code
  requestCode: (payload: CodeRequestPayload): Promise<{ message: string }> => {
    return apiRequest.post('/auth/request-login-code', payload);
  },

  // Verify code and login
  verifyCode: (payload: CodeVerificationPayload): Promise<LoginResponse> => {
    return apiRequest.post('/auth/login-with-code', payload);
  },

  // Get current user info
  getCurrentUser: (): Promise<LoginResponse['data']['user']> => {
    return apiRequest.get('/auth/me');
  },

  // Logout
  logout: (): Promise<{ message: string }> => {
    return apiRequest.post('/auth/logout');
  },

  // Request password reset code
  forgotPassword: (payload: ForgotPasswordPayload): Promise<{ message: string }> => {
    return apiRequest.post('/auth/forgot-password', payload);
  },

  // Reset password with code
  resetPassword: (payload: ResetPasswordPayload): Promise<{ message: string }> => {
    return apiRequest.post('/auth/reset-password', payload);
  },

  // Register new user
  register: (payload: RegisterPayload): Promise<LoginResponse> => {
    return apiRequest.post('/auth/register', payload);
  },

  // Refresh access token
  refreshToken: (refreshToken: string): Promise<LoginResponse> => {
    return apiRequest.post('/auth/refresh', { refreshToken });
  },
};